import { StyledIcon } from '../Icon.Styled'
import { IconProps } from '../Icon.Types'

export const SfLockIcon = (props: IconProps) => {
  return (
    <StyledIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.80762 20.2852C7.12793 20.2852 6.6123 20.1006 6.26074 19.7314C5.90918 19.3682 5.7334 18.8174 5.7334 18.0791V11.7246C5.7334 10.9922 5.90918 10.4443 6.26074 10.0811C6.6123 9.71777 7.12793 9.53613 7.80762 9.53613H16.1836C16.8691 9.53613 17.3848 9.71777 17.7305 10.0811C18.082 10.4443 18.2578 10.9922 18.2578 11.7246V18.0791C18.2578 18.8174 18.082 19.3682 17.7305 19.7314C17.3848 20.1006 16.8691 20.2852 16.1836 20.2852H7.80762ZM7.39453 10.3184V7.49707C7.39453 6.43066 7.60547 5.53125 8.02734 4.79883C8.45508 4.06641 9.01758 3.5127 9.71484 3.1377C10.4121 2.75684 11.1709 2.56641 11.9912 2.56641C12.8174 2.56641 13.5791 2.75684 14.2764 3.1377C14.9795 3.5127 15.542 4.06641 15.9639 4.79883C16.3916 5.53125 16.6055 6.43066 16.6055 7.49707V10.3184H14.7773V7.35645C14.7773 6.71191 14.6484 6.16406 14.3906 5.71289C14.1387 5.26172 13.8018 4.91895 13.3799 4.68457C12.9639 4.4502 12.501 4.33301 11.9912 4.33301C11.4873 4.33301 11.0244 4.4502 10.6025 4.68457C10.1865 4.91895 9.85254 5.26172 9.60059 5.71289C9.35449 6.16406 9.23145 6.71191 9.23145 7.35645V10.3184H7.39453Z"
        fill="currentColor"
      />
    </StyledIcon>
  )
}
